'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _utils = require('../utils');

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var videoWrapper = context.getElement('.' + context.className + '_Wrapper');
  var video = context.getElement('.' + context.className + '_Player');
  var desktopAutoplayVideo = context.getElement('.' + context.className + '_DesktopPlayer');
  var mobileAutoplayVideo = context.getElement('.' + context.className + '_MobilePlayer');
  var trigger = context.getElement('.' + context.className + '_Trigger');
  var pauseButton = context.getElement('.' + context.className + '_PauseButton');
  var content = context.getElement('.' + context.className + '_Content');

  if (typeof video !== 'undefined' && video != null) {
    video.load();
    trigger.addEventListener('click', playVideo);
    pauseButton.addEventListener('click', pauseVideo);
  }

  playPauseVideos();
  window.addEventListener('resize', playPauseVideos);

  function playVideo() {
    content.classList.add('her-Hero_Content-hide');
    videoWrapper.classList.add('her-Hero_Video-playbackShow');
    video.play();
    if (typeof desktopAutoplayVideo !== 'undefined' && desktopAutoplayVideo != null) {
      desktopAutoplayVideo.pause();
    }
    if (typeof mobileAutoplayVideo !== 'undefined' && mobileAutoplayVideo != null) {
      mobileAutoplayVideo.pause();
    }
  }

  function pauseVideo() {
    content.classList.remove('her-Hero_Content-hide');
    videoWrapper.classList.remove('her-Hero_Video-playbackShow');
    video.pause();
    if (typeof desktopAutoplayVideo !== 'undefined' && desktopAutoplayVideo != null) {
      desktopAutoplayVideo.play();
    }
    if (typeof mobileAutoplayVideo !== 'undefined' && mobileAutoplayVideo != null) {
      mobileAutoplayVideo.play();
    }
  }

  function playPauseVideos() {
    if (window.innerWidth > _utils.mediaBreakpoints.sm) {
      if (typeof desktopAutoplayVideo !== 'undefined' && desktopAutoplayVideo != null) {
        desktopAutoplayVideo.play();
      }
      if (typeof videoMobile !== 'undefined' && mobileAutoplayVideo != null) {
        mobileAutoplayVideo.pause();
      }
    } else {
      if (typeof mobileAutoplayVideo !== 'undefined' && mobileAutoplayVideo != null) {
        mobileAutoplayVideo.play();
        desktopAutoplayVideo.pause();
      }
    }
  }
}